export type JobItem = {
  attributes: ItemAttributes
  comment: string
  claimInformation?: { maxClaimDate: string; availableClaimActions: ClaimActions[] }
  rejectionInformation?: {
    rejectionReason: string
    claimAction: ClaimActions
    claimState: string
    comment: string
    evidence: string[]
  }
  foundQuantity: number
  name: string
  origin: string
  photoUrl: string
  status: string
  quantity: number
  isSubstitute: boolean
  replacedBy?: any
  reference: string
  packageName?: string
  packageReference?: string
  presentationV2: ItemPresentationV2
  presentation: ItemPresentation
  barcodes: string[]
  pickingInfo?: any
  rejected: RejectedItem
  taskId: string
  kitInfo?: any
  availableLots?: any
  createdAt?: string
  updatedAt?: string
  packageId?: any
  quantityFoundLimits: QuantityFoundLimitsInItems
  replacementMode?: string
  suggestedReplacements?: string[]
  priceDetails?: any
  pickingTaskId?: string
  pickerId?: any
  pickedAt?: any
  pickingIndex?: number
  department?: string
  stateReason?: any
  suggestedReplacementsV2?: SuggestedReplacementItem
  itemNumber?: string
  state?: string
  itemId: string
}

export type ItemChanges = {
  id: number
  itemId: string
  jobId: number
  name: string
  quantity: number
  foundQuantity: number
  photoUrl: string
  presentation: ItemChangesPresentation
  history: ItemChangesHistory[]
  createdAt: string
  updatedAt: string
  clientId: number
}

export type ItemChangesPresentation = {
  unit: string
  price: number
  volume: number
  weight: number
  formats: any
  subUnit: string
  quantity: number
  subQuantity: number
}

export type ItemChangesHistory = {
  oldStatus?: string
  isSubstituteOf?: string
  removedBy?: string
  status: string
  isSubstitute: boolean
  timestamp: number
  origin: string
  replacedBy: any
  isAdded: boolean
  isRemoved: boolean
  isRejected: boolean
  itemRejected: any
}

export type ItemAttributes = {
  ean?: string
  plu?: string
  category?: string
  location?: string
  othersAttributes?: string
  pickingIndex?: number
  sku?: string
  equivalence?: string
  originalPrice?: number
  posPrice?: number
}

export interface ItemPresentation {
  name: string
  unit: string
  price: Price
  weight: number
  quantity: number
  dimensions: any[]
}

export interface Price {
  amount: number
  currencyCode: string
}

export type ItemPresentationV2 = {
  unit: string
  price: number
  weight: number
  quantity: number
  volume?: number
  formats?: any
  subUnit?: string
  subQuantity?: number
}

export type RejectedItem = {
  rejectedByPicker: number
  rejectedByDriver: number
  rejectedByUser: number
}

export type QuantityFoundLimitsInItems = {
  min: number
  max: number
}

export interface ReplacementsItemIds {
  replacements: string[]
}

export type SuggestedReplacementItem = {
  clientSuggestions?: ReplacementsItemIds
  pickerSuggestions?: ReplacementsItemIds
}

export type ChangeHistoryItem = {
  changeBy: string
  date: string
  actionType: string
  item: replacementItem[]
  replacementItem: replacementItem[]
}

export type replacementItem = {
  id: string
  image?: string
  name?: string
  description?: string
  price?: number
}

export type JobProductItem = {
  id: string
  image: string
  name: string
  description: string
  quantity: number
  quantityFound?: number
  comment: string
  unitValue: string
  unit: string
  actionType: string
  addedBy: string
  attributes: ItemAttributes
  replacementItem?: replacementItem[]
}

export enum ORIGIN_ITEM_CHANGES {
  ODIN = 'ODIN',
  CONTROL_TOWER = 'CONTROL_TOWER',
  PICKER = 'PICKER',
  BIFROST = 'BIFROST',
  CLIENT = 'CLIENT',
  LSW = 'LSW',
  AGENT = 'AGENT'
}

export enum ITEM_STATES {
  PENDING = 'PENDING',
  ADDED = 'ADDED',
  REMOVED = 'REMOVED',
  CANCELLED = 'CANCELLED',
  REJECTED = 'REJECTED',
  CHANGED_ORIGINAL_QUANTITY = 'CHANGED_ORIGINAL_QUANTITY',
  ORIGINAL_QUANTITY_CHANGED_BY_PICKER = 'ORIGINAL_QUANTITY_CHANGED_BY_PICKER'
}

export enum GET_STATUS_BAR_COLOR_BY_STATE {
  PENDING = '#B8BABF',
  ADDED = '#52C41A',
  REMOVED = '#FADB14',
  REJECTED = '#f2473a'
}

export enum ACTION_TYPE_BY_ITEM_STATUS {
  CANCELLED = 'REMOVED_BY_PICKER',
  REMOVED = 'REMOVED_BY_PICKER',
  REMOVED_BY_AGENT = 'REMOVED_BY_AGENT',
  REJECTED_BY_USER = 'REJECTED_BY_CLIENT',
  USER_REJECTION = 'REJECTED_BY_CLIENT',
  REJECTED_BY_DRIVER = 'REJECTED_BY_DRIVER',
  DRIVER_REJECTION = 'REJECTED_BY_DRIVER',
  ADDED = 'ADDED_BY_PICKER',
  ADDED_BY_AGENT = 'ADDED_BY_AGENT',
  ADDED_BY_CLIENT = 'ADDED_BY_CLIENT',
  REPLACED_BY_PICKER = 'REPLACED_BY_PICKER',
  PENDING = 'PENDING_BY_PICKER',
  USER_UNDO_REJECTION = 'RETURNED_TO_ADDED_BY_CLIENT',
  DRIVER_UNDO_REJECTION = 'RETURNED_TO_ADDED_BY_DRIVER',
  ORIGINAL_QUANTITY_CHANGED_BY_PICKER = 'ADDED_BY_PICKER'
}

export enum ACTION_TEXT_BY_ITEM_STATUS {
  CANCELLED = 'itemChangesRemovedByPicker',
  REMOVED = 'itemChangesRemovedByPicker',
  REMOVED_BY_AGENT = 'itemChangesRemovedByAgent',
  REJECTED_BY_USER = 'itemChangesRejectedByClient',
  USER_REJECTION = 'itemChangesRejectedByClient',
  REJECTED_BY_DRIVER = 'itemChangesRejectedByDriver',
  DRIVER_REJECTION = 'itemChangesRejectedByDriver',
  ADDED = 'itemChangesAddedByPicker',
  ADDED_BY_AGENT = 'itemChangesAddedByAgent',
  ADDED_BY_CLIENT = 'itemChangesAddedByClient',
  REPLACED_BY_PICKER = 'itemChangesReplacedByPicker',
  PENDING = 'itemChangesPendingByPicker',
  USER_UNDO_REJECTION = 'itemChangesUndoRejectionByClient',
  DRIVER_UNDO_REJECTION = 'itemChangesUndoRejectionByDriver',
  ORIGINAL_QUANTITY_CHANGED_BY_PICKER = 'originalQuantityChangedByPicker'
}

export type ClaimActions =
  | 'REFUND'
  | 'SUBSTITUTE'
  | 'COLLECT_AND_REFUND'
  | 'COLLECT_AND_SUBSTITUTE'
  | 'REJECT'
  | 'REJECTION_NOT_ALLOWED'
